module.exports = __webpack_public_path__ + "static/media/Sara.1035870c.jpeg";